// openAdapter失敗（BT OFF 等）を型付きで表す。元のrejection値をoriginalErrorで無損失保持し、
// classifyFailureはinstanceofで分類する（name文字列比較・catch内stringifyを廃す）。
// フィールド名がcauseでないのは、TS4.6.2同梱libの Error.cause 型（Error|undefined）と衝突して
// unknownを保てなくなるのを避けるため。将来 analytics を実シンクへ出す層（aikasa/ikasa_platform#7594）もこのフィールドを読む（標準.causeに非依存）。
export class BluetoothNotOnException extends Error {
  constructor(readonly originalError: unknown) {
    super('bluetooth adapter is not on')
    this.name = 'BluetoothNotOnException'
    Object.setPrototypeOf(this, BluetoothNotOnException.prototype)
  }
}
